var shopdomain = Shopify.shop;
var appdomain = 'https://phpstack-726259-2422117.cloudwaysapps.com';
var app_class_array = ['.custom-cart-footer'];
var variant_id = 33306272432210;
$.ajax({
  type: "GET",
    url: appdomain + '/widget?shop=' + shopdomain,
    success: function (data) {
      if (data.status == 'success') {

        var enable = true;
        $(app_class_array).each(function(index, selector){
          if(enable){
            $(selector).prepend(`<div id="wrap-it-widget"></div>`);
            $(selector).find('div#wrap-it-widget').append(data.html);
            enable = false;
          }
        });

        let cart_ids = [];

        $.ajax({
          type: "GET",
            url: '/cart.js',
            async:false,
            success: function (data) {
              var response = JSON.parse(data);
              cart_notes = response.note;
              response.items.forEach(function(cart_item){
                cart_ids.push(cart_item.id);
              });
            }
        });




        if($('#js-switch').is(':checked'))
        {
          add_to_cart(cart_ids,variant_id);
        }
        else if(cart_ids.includes(variant_id))
        {
          $('#js-switch').prop('checked',true);
        }


        $(document).on('change', '#js-switch', function() {

          if($(this).is(':checked'))
          {

            deleteCookie('insurance');
  			let cart_ids = [];

            $.ajax({
              type: "GET",
                url: '/cart.js',
                success: function (data) {
                  var response = JSON.parse(data);
                  cart_notes = response.note;
                  response.items.forEach(function(cart_item){
                    cart_ids.push(cart_item.id);
                  });
                  
                  add_to_cart(cart_ids,variant_id);
                }
            });
            
            
          }
          else
          {              
            remove_from_cart(variant_id);
          }
        });
      }
    },
  error: function (jqXHR, textStatus, errorThrown) {
    console.log(jqXHR, textStatus, errorThrown);
  }
});


function add_to_cart(cart_ids,variant_id){


  var cookie = getCookie('insurance');

  if(!cart_ids.includes(variant_id) && cookie != 'removed') {
    $.ajax({
     type: "POST",
      url: '/cart/add.js',
      data:
      {
        items: [
          {
            quantity: 1,
              id: variant_id,
          }
        ]
      },
      success: function (data) {
         $.ajax({
          type: "GET",
            url: '/cart.js',
            async:false,
            success: function (res) {
              var response = JSON.parse(res);
              var new_total = response.total_price/100;
              $('.custom-cart-price').text("$" +new_total.toFixed(2) + "");
              
            }
        });
     } 
              
    });

  }
  else {
    if(cart_ids.includes(variant_id))
    {
    	$('#js-switch').prop('checked',true);
      	$.ajax({
          type: "GET",
            url: '/cart.js',
            async:false,
            success: function (res) {
              var response = JSON.parse(res);
              var new_total = response.total_price/100;
              $('.custom-cart-price').text("$" +new_total.toFixed(2) + "");
              
            }
        });
    }
    else
    $('#js-switch').prop('checked',false);
  }

}

function remove_from_cart(variant_id){
  
   $.ajax({
     type: "POST",
      url: '/cart/change.js',
      data:
      {
        quantity: 0,
        id: variant_id,
      },
      success: function (data) {
         $.ajax({
          type: "GET",
            url: '/cart.js',
            async:false,
            success: function (res) {
              var response = JSON.parse(res);
              var new_total = response.total_price/100;
              $('.custom-cart-price').text("$" +new_total.toFixed(2) + "");
              
              setCookie('insurance', 'removed');
              $('.custom-insurence-line-item').remove();
              
        
        	  //setTimeout(function() {window.location.reload();}, 1000);
            }
        });
        
     } 
             
   
    });
}


function deleteCookie(cvalue) {
  document.cookie = "insurance=";
}


function setCookie(cname, cvalue) {

  var old_value = getCookie('insurance');

  if(cvalue == "")
  document.cookie = "insurance=";
  else if(old_value != "removed")
  document.cookie = cname + "=" + cvalue + ";path=/";
}

function getCookie(cname) {
  let name = cname + "=";
  let ca = document.cookie.split(';');
  for(let i = 0; i < ca.length; i++) {
    let c = ca[i];
    while (c.charAt(0) == ' ') {
      c = c.substring(1);
    }
    if (c.indexOf(name) == 0) {
      return c.substring(name.length, c.length);
    }
  }
  return "";
}